import '../css/style.css'

export default function Content() {
    return(
        <div className='content'>
            <div className='desc'>Wykorzystując wieloletnie doświadczenie oraz zaplecze sprzętowe oferujemy pełny zakres usług dla użytkowników sprężarek powietrza Centac, Cameron, Cooper, Joy, Atlas Copco i innych producentów w celu poprawy niezawodności oraz wydajności maszyn.</div>
            <div className='title'>W ramach usług serwisowych wykonujemy:</div>
            <div className='list'>
                        <div className="ol">1. Prace serwisowe:</div>
                        <ul>
                            <li>remonty i przeglądy części mechanicznej maszyn</li>
                            <li>remonty i przeglądy układu przepływowego</li>
                            <li>remonty i przeglądy systemów sterowania oraz regulacji wydajności</li>
                            <li>modernizacje sterowania i układów regulacji wydajności</li>
                        </ul>
                        <div className="ol">2. Prace serwisowe warsztatowe:</div>
                        <ul>
                            <li>regeneracja łożysk ślizgowych</li>
                            <li>regeneracja zębatych wałków szybkoobrotowych</li>
                            <li>odbudowa geometrii łopatek wirników</li>
                            <li>wyważanie dynamiczne rotorów według norm VDI</li>
                        </ul>
                        <div className="ol">3. Doradztwo techniczne i inżynieria odwrotna</div>
            </div>
        </div>
    )
}